import { AngebotSparte } from '@mng/sales-types';
import { Antragdata } from '../../antrag.model.types';

export function hatAntragSpartenAngebot(antrag: Antragdata, spartenKennzeichen: string): boolean {
  return !!antrag.angeboteMetaData.find((angebot) => angebot.sparte === spartenKennzeichen);
}

export function hatAntragSpartenAngebotGv(antrag: Antragdata): boolean {
  return hatAntragSpartenAngebot(antrag, AngebotSparte.G);
}

export function hatAntragSpartenAngebotLv(antrag: Antragdata): boolean {
  return hatAntragSpartenAngebot(antrag, AngebotSparte.L);
}

export function hatAntragSpartenAngebotUv(antrag: Antragdata): boolean {
  return hatAntragSpartenAngebot(antrag, AngebotSparte.U);
}
